import React from 'react'
import {whatsapp, email,barely_black_bg_img, contactusbg, location, contact, email1 } from '../../../public/LoginImages/importimages'

const ContactUs = () => {
   
  return (
    <>
      {/* <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', color: 'white', backgroundImage: `url('${contactusbg}')`, backgroundSize:'contain', padding: '45px' }}>
        <h2>Contact Us</h2>
        <p style={{ lineHeight: '20px', textAlign: 'center', fontSize: '15px' }}> Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat volutpat. Ut
          wisi enim ad minim veniam, quis nostrud exerci tation ullamcorper suscipit lobortis nisl ut aliquip ex ea commodo consequat. Duis autem vel eum iriure
          dolor in hendrerit in vulputate velit esse molestie consequat, vel illum dolore eu feugiat nulla facilisis at vero eros et accumsan et iusto odio dignissim qui
          blandit praesent luptatum zzril delenit augue duis dolore te feugait nulla facilisi
        </p>
        <input style={{ color: 'orange', backgroundColor: 'white', border: 'none', borderRadius: '10px', padding: '10px 30px', fontWeight: 'bold' }} type="button" onClick={() => window.location = 'mailto:nagarnigam.bareilly@gmail.com'} value="Contact Us" />
      </div> */}

      <div style={{ display: 'flex', flexWrap: 'wrap', padding: '70px', backgroundImage: `url('${barely_black_bg_img}')`,backgroundSize:'contain' }}>
        <div style={{
          height: '54vh', width: '100%', backgroundColor: 'gray', padding: '5%', color: 'white', textAlign:'center'
        }} className='box1'>
          <h2>Contact Us</h2>

          <div style={{ display: 'flex', gap: '1vw' }}>
            <img width='20px' height='20px' src={location}></img>
            <p>
              Nagar Nigam, Bareilly
              Opp: Bareilly College, Bareilly
              Civil Lines, Bareilly (U.P.) Pin - 243001
            </p>
          </div>

          <div style={{ display: 'flex', gap: '1vw' }}>
            <img width='20px' height='20px' src={contact}></img>
            <p>
              0581-6612200 /
              7055519637
            </p>
          </div>

          <div style={{ display: 'flex', gap: '1vw' }}>
            <img width='20px' height='20px' src={email1}></img>
            <p>
            nagarayukt.bareilly@gmail.com
            </p>
          </div>
        </div>

        {/* <div style={{ height: '50vh', width: '40vw', padding: '50px', backgroundColor: 'white'}} className='box2'>
          <h2>Get In Touch</h2>
          <p>
            Lorem ipsum dolor sit amet, consectetuer adipiscing elit, sed diam
            nonummy nibh euismod tincidunt ut laoreet dolore magna aliquam erat
          </p>
          <p>
            <a href=''>
              <img src={whatsapp} style={{ height: '4rem', width: '4rem' }}></img>
            </a>
            <a href=''>
              <img src={email} style={{ height: '4rem', width: '4rem', marginLeft: '20px' }}></img>
            </a>
          </p>
        </div> */}
      </div>

    </>
  )
}

export default ContactUs